<app-batch-table-filter></app-batch-table-filter>
<app-batch-table></app-batch-table>
